// extracted by mini-css-extract-plugin
module.exports = {"pageWidth":"1920px","pageHeight":"1080px"};